import React from 'react';
import {getVerticalFooterData} from './footer-data';

function Footer(props) {
  const {vertical} = props;
  const popularList = getVerticalFooterData(vertical);

  // dynamic links are explicitly done as string literal to save data size. otherwise we will need to send data to store to support client side rendering
  const dynamicLink = popularList
    .map(
      item =>
        `<p class="fl width100">
      <span class="greyLter ico12 fb fl padR5">${item.block_title}</span>
      ${item.links_data
        .map(
          element =>
            `<a href=${element.link}>
          ${element.name} |
        </a>`,
        )
        .join('')}
    </p>`,
    )
    .join('');
  return (
    <div className="footerBox mobdn posRel">
      <div className="website-badge-Bottom">
        <a className="awsAward" href="https://yourstory.com/aws-mobility/" target="_blank">
          &nbsp;
        </a>
      </div>
      <div className="maxWidth1020 marginAuto">
        <div className="col-md-10 col-sm-12 padB20">
          <ul className="col-md-3 col-sm-3 footerLinks">
            <li className="txtTransUpper font12 greyDr fb padB10">our products</li>
            <li>
              <a href="/hotels/">Domestic Hotels</a>
            </li>
            <li>
              <a href="/hotels-international/">International Hotels</a>
            </li>
            <li>
              <a href="/flights/">Domestic Flights</a>
            </li>
            <li>
              <a href="/international-flights/">International Flights</a>
            </li>
            <li>
              <a href="/bus/">Bus Booking</a>
            </li>
            <li>
              <a href="/cars/">Cab Booking</a>
            </li>
            <li>
              <a href="/trains/">Train Ticket Booking</a>
            </li>
            <li>
              <a href="/routeplanner/">Route Planner</a>
            </li>
            <li>
              <a href="/destinations/">Destination Planner</a>
            </li>
          </ul>
          <ul className="col-md-3 col-sm-3 footerLinks">
            <li className="txtTransUpper font12 greyDr fb padB10">Company</li>
            <li>
              <a href="/aboutus/">About Us</a>
            </li>
            <li>
              <a href="/info/terms-of-services/">Terms of Services</a>
            </li>
            <li>
              <a href="/info/user-agreement/">User Agreement</a>
            </li>
            <li>
              <a href="/info/privacy/">Privacy</a>
            </li>
            <li>
              <a href="/support/">Contact Us</a>
            </li>
            <li>
              <a href="/careers/" target="_blank">
                Careers
              </a>
            </li>
            <li>
              <a href="/info/corporate-social-responsibility/">Corporate Social Responsibility</a>
            </li>
            <li>
              <a href="/mobile/">Goibibo on Mobile</a>
            </li>
            <li>
              <a href="https://www.youtube.com/user/goibibo">Goibibo TV Advertisement</a>
            </li>
            <li>
              <a href="https://tech.goibibo.com/" target="_blank">
                Technology@Goibibo
              </a>
            </li>
          </ul>
          <ul className="col-md-3 col-sm-3 footerLinks">
            <li className="txtTransUpper font12 greyDr fb padB10">travel resources</li>
            <li>
              <a href="/bus/bus-routes/">Popular Bus Routes</a>
            </li>
            <li>
              <a href="/trains/check-pnr-status/">Train PNR Status</a>
            </li>
            <li>
              <a href="/cars/airport-cabs/">Airport Cabs</a>
            </li>
            <li>
              <a href="/hotels/india/">Hotels in India</a>
            </li>
            <li>
              <a href="/airlines/">Popular Airlines</a>
            </li>
            <li>
              <a href="/offers/">Goibibo Offers</a>
            </li>
            <li>
              <a href="/airports/">International Airports</a>
            </li>
            <li>
              <a href="/flights/city-to-city-airlines/">City Airline Routes</a>
            </li>
            <li>
              <a href="/destinations/intl/">International Travel Guide</a>
            </li>
          </ul>
          <ul className="col-md-3 col-sm-3 footerLinks">
            <li className="txtTransUpper font12 greyDr fb padB10">more links</li>
            <li>
              <a href="/flights/cheap-flights/">Cheap Flights</a>{' '}
            </li>
            <li>
              <a href="/trains/check-train-running-status/">Train Running Status</a>
            </li>
            <li>
              <a href="/flight-schedule/">Flight Schedule</a>
            </li>
            <li>
              <a href="/gostays/">Go Stays</a>
            </li>
            <li>
              <a href="/bus/city-buses/">Popular Bus Cities</a>
            </li>
            <li>
              <a href="/airports/airports-in-india/">Airports in India</a>
            </li>
            <li>
              <a href="/hotels/chain/">Popular Hotel Chains</a>
            </li>
            <li>
              <a href="/info/hotels-near-me/">Hotels Near Me</a>
            </li>
          </ul>
        </div>
        <div className="col-md-12 col-sm-12 padTB20 fotDPLink borderTop">
          <div
            className="width100 fl pDTB20 fotDPLink"
            dangerouslySetInnerHTML={{
              __html: dynamicLink,
            }}
          >
            {/*popularList.map(item => (
              <p className="fl width100" key={item.slug}>
                <span className="greyLter ico12 fb fl padR5">{item.block_title}</span>
                {item.links_data.map(element => (
                  <a href={element.link} key={element.link}>
                    {element.name} |
                  </a>
                ))}
              </p>
            ))*/}
          </div>
        </div>
        <div className="col-md-12 col-sm-12 col-xs-12 footerAppLinks">
          <div className="col-md-2 col-sm-3">
            <p className="ico14 fb">Follow Us</p>
            <div className="padT10">
              <a
                target="_blank"
                href="http://www.facebook.com/goibibo"
                className="fl padR10"
                title="facebook"
              >
                <i className="ico24 lh1-2  greyLt icon-facebook"></i>
              </a>
              <a
                target="_blank"
                href="http://twitter.com/goibibo"
                className="fl padR10"
                title="Twitter"
              >
                <i className="ico26 lh1-2  greyLt icon-twitter"></i>
              </a>
              <a
                target="_blank"
                href="http://www.youtube.com/user/goibibo"
                className="fl padR10"
                title="youtube"
              >
                <i className="ico28 greyLt icon-youtube"></i>
              </a>
              <a
                target="_blank"
                href="https://plus.google.com/+goibibo/"
                className="fl"
                title="Google Plus"
              >
                <span className="hd_vs fr_gplus margin0">&nbsp;</span>
              </a>
            </div>
          </div>
          <div className="col-md-5 col-sm-6">
            <p className="ico14 fb">Book Tickets faster. Download our mobile Apps</p>
            <div className="padT10">
              <a
                target="_blank"
                className="fthm-mobApp fthm-goog fl marginR5"
                href="http://app.appsflyer.com/com.goibibo?pid=mobile_site&amp;c=m_header"
              ></a>
              <a
                target="_blank"
                className="fthm-mobApp fthm-app fl marginR5"
                href="https://itunes.apple.com/in/app/goibibo-flight-bus-hotel-booking/id631927169?mt=8"
              ></a>
              <a
                target="_blank"
                className="fthm-mobApp fthm-windows fl"
                href="http://www.windowsphone.com/en-in/store/app/goibibo/6f16a6ec-3b7e-4782-9f74-57f75a4cc1a3"
              ></a>
            </div>
          </div>
          <div className="col-md-5 col-sm-3 marginT5 pad0">
            <span className="commonSprite fl verifySign marginR10">&nbsp;</span>
            <span className="commonSprite fl americanExp marginT5 marginR10 ipaddn">&nbsp;</span>
            <span className="commonSprite fl masterCard marginT5 marginR10 ipaddn">&nbsp;</span>
            <span className="commonSprite fl visaCard marginT5 marginR10 ipaddn">&nbsp;</span>
            <span className="commonSprite payu marginT5 marginR10">&nbsp;</span>
            <span className="commonSprite rupay marginT2 marginR10 ipaddn">&nbsp;</span>
            <span className="commonSprite iata marginR10">&nbsp;</span>
          </div>
        </div>
        <div className="col-md-12 col-sm-12 col-xs-12 footerCopyrights">
          <div className="col-md-8">
            <a className="commonSprite ibGrp" target="_blank" href="http://www.ibibo.com/"></a>
            <span className="commonSprite backslash" href="#"></span>
            <a className="commonSprite goib" target="_blank" href="http://www.goibibo.com/"></a>
            <a
              rel="nofollow"
              className="commonSprite redBus"
              target="_blank"
              href="http://www.redbus.in/"
            ></a>
            {/* <a rel="nofollow" className="commonSprite ads" target="_blank" href="http://www.ibiboads.com/"></a>
                <a rel="nofollow" className="commonSprite ryde" target="_blank" href="http://www.ibiboryde.com/"></a> */}
          </div>
          <div className="fr padT10">
            &copy;
            {' ' + new Date().getFullYear() + ' ibibogroup All rights reserved'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
